import React from 'react';
import { CtaButton } from './CtaButton';
export function Hero() {
  return <header className="relative w-full overflow-hidden border-b border-bark/10 bg-cream" data-id="element-143" data-mp="ejwib60ji54o">
      <div className="mx-auto max-w-3xl px-5 py-14 text-center sm:px-8 lg:py-20" data-id="element-144" data-mp="ei1v1l1sq0xf">
        <p className="mb-6 inline-flex items-center gap-2 rounded-full border border-sage/40 bg-sage/10 px-3 py-1.5 text-xs font-medium text-sageDeep" data-id="element-145" data-mp="9l375k8q6q7o">
          <span className="h-1.5 w-1.5 rounded-full bg-sage" aria-hidden="true" data-id="element-146" data-mp="129qtzk94hnnc" />
          Protocolo de desinflamación biológica · 7 días
        </p>

        <h1 className="font-display text-[2.1rem] font-semibold leading-[1.08] tracking-tight text-bark sm:text-5xl lg:text-[3.4rem]" data-id="element-147" data-mp="x8b7dnrar92u">
          ¿Y si el problema no fuera tu peso, sino que tu cuerpo tiene{' '}
          <span className="text-clay" data-id="element-148" data-mp="nekkuoeqd8ps">“miedo”</span>?
        </h1>

        <p className="mx-auto mt-6 max-w-xl font-display text-lg leading-snug text-ink/80 sm:text-xl" data-id="element-149" data-mp="3d33eqyadctkr">
          No es que estés gorda. No es que seas débil. No es que no tengas suficiente disciplina.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-ink/85 sm:text-lg" data-id="element-150" data-mp="3j9alrqbghebh">
          Lo que está pasando es más profundo: tu cuerpo entró en un estado llamado{' '}
          <strong className="font-semibold text-bark" data-id="element-151" data-mp="399tdd14tkmbt">Supervivencia</strong>. Y cuando eso ocurre, la
          inflamación no es un error, es una orden biológica.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-ink/85 sm:text-lg" data-id="element-152" data-mp="30gzwiz9q5evu">
          Descubre por qué las dietas y el gimnasio te están hinchando más.{' '}
          <strong className="font-semibold text-bark" data-id="element-153" data-mp="2qk3hsbt8fwiu">El Código Cortisol</strong> es el primer
          protocolo de 7 días diseñado para sacar a tu cuerpo del{' '}
          <em className="not-italic font-medium text-bark" data-id="element-154" data-mp="2vgu1d948xa90">“Estado de Supervivencia”</em>, drenar la
          inflamación abdominal y devolverle los ángulos naturales a tu rostro.
        </p>

        <div className="relative mx-auto mt-10 max-w-lg" data-id="element-155" data-mp="2ljz5yz39rpyy">
          <div className="absolute inset-x-8 bottom-4 top-10 rounded-3xl bg-sand" aria-hidden="true" data-id="element-156" data-mp="s2bc6ahwz5ay" />
          <img src="https://cdn.magicpatterns.com/uploads/dpPwDsYjA9MKgeko8FLieC/mokupcodigocortiso.png" alt="Código Cortisol: protocolo de 7 días, mostrado en una tablet" className="relative w-full rounded-3xl object-cover shadow-lift" loading="eager" data-id="element-157" data-mp="naa0aponrglg" />
        </div>

        <div className="mt-10 flex justify-center" data-id="element-158" data-mp="1b0nk5sx3a94y">
          <CtaButton data-id="element-159" data-mp="1b0du65c1o1z9">QUIERO DESINFLAMARME AHORA</CtaButton>
        </div>
      </div>
    </header>;
}